<template>
  <div class="container">
    <PublicHeader :totalName="$t('common').helpcenter" />
    <!-- 列表 -->
    <div class="listInfo">
      <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getContentList"
        :immediate-check="false">
        <div class="item" v-for="(dItem, dIndex) in oList" :key="`help${dIndex}`"
          @click="$router.push({ name: 'Detail', query: { Name: $t('common').helpcenter, id: dItem.contentLocalizationId } })">
          <div class="left">
            <div class="ico">
              <img src="@/assets/img/common_help.png" />
            </div>
            <div class="name">{{ dItem.localizationTitle }}</div>
          </div>
          <van-icon name="arrow" size="13" color="var(--ntext_color)" />
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PublicHeader from '@/components/publicHeader'
import systemApi from '@/api/system'

export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
        type: '2'
      },
      oList: [],
    }
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {
    this.getContentList()
  },
  methods: {
    // 获取内容列表
    async getContentList() {
      if (this.isRun) return
      this.isRun = true
      const res = await systemApi.getContentList(this.parms)
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding: 60px 15px 15px 15px;
  background: var(--background_color);

  .listInfo {
    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;

      .left {
        width: 300px;
        display: flex;
        align-items: center;

        .ico {
          background: #FEB220;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 15px;
            height: 15px;
          }
        }

        .name {
          width: 220px;
          margin-left: 15px;
          font-size: 15px;
          font-weight: bold;
          color: var(--text_color);
          line-height: 20px;
        }
      }
    }
  }
}
</style>
